// packages/shared-hooks/src/clients/useRestoreLegalEntityRequisites.ts
//
// `POST /clients/:id/legal-entities/:leId/requisites/:requisitesId/restore` —
// brings an archived bank set back. Archived sets stay readable in the UI, so
// this is the only path that makes one editable again.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LegalEntityRequisitesSchema, type LegalEntityRequisites } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useRestoreLegalEntityRequisites(
  clientId: string,
  legalEntityId: string,
  requisitesId: string,
) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LegalEntityRequisites, unknown, void>({
    mutationFn: () =>
      client.post<LegalEntityRequisites>(
        `/clients/${clientId}/legal-entities/${legalEntityId}/requisites/${requisitesId}/restore`,
        undefined,
        {},
        LegalEntityRequisitesSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
